import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export const createUrl = (baseUrl: string, filterId: string): string =>
	`/rest/agile/1.0/board/filter/${filterId}`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	filterId: string,
): Promise<{
	values: [];
}> => fetchJson(createUrl(baseUrl, filterId));
